import CallFilled from '@ixigo/icons/CallFilled';
import Close from '@ixigo/icons/Close';
import Button from '@ixigo/iui/Button';
import { BottomsheetExtended as Bottomsheet } from '@repo/shared/components';
import { EmergencyFilled } from '@repo/shared/icons';
import { Fragment, useState } from 'react';
import type { CabUpdateResponse } from '@/api';
import { NavigationHeader } from '@/components';
import { ListCard } from './list-card/list-card';

interface SOSFabProps extends Pick<CabUpdateResponse, 'emergencyContact'> {}

export function SOSFab(props: SOSFabProps) {
	const { emergencyContact } = props;
	const [isOpen, setIsOpen] = useState(false);

	const onClose = () => {
		setIsOpen(false);
	};

	return (
		<Fragment>
			<div className="fixed bottom-16 right-20 z-[1]">
				<Button
					size="lg"
					color="brand"
					className="rounded-full shadow-100"
					onClick={() => setIsOpen(true)}
				>
					SOS
				</Button>
			</div>
			<Bottomsheet
				open={isOpen}
				onClose={() => setIsOpen(false)}
				classes={{
					container: 'w-full',
				}}
			>
				<NavigationHeader
					title="Need Help?"
					leftIcon={<Close />}
					leftAction={onClose}
					className="border-b border-tertiary"
				/>
				<div className="px-20 py-10">
					<ListCard
						title="Call Emergency"
						subtitle="Connect with police, ambulance, or fire services instantly."
						icon={<EmergencyFilled />}
						onClick={() => {
							window.open(`tel:${emergencyContact?.sosPhoneNumber}`, '_blank');
						}}
						className="border-b border-tertiary last-of-type:border-b-0"
					/>
					<ListCard
						title="Call ixigo"
						subtitle="We usually answer calls in 30 sec"
						icon={<CallFilled />}
						onClick={() => {
							window.open(
								`tel:${emergencyContact?.ixigoPhoneNumber}`,
								'_blank',
							);
						}}
					/>
				</div>
			</Bottomsheet>
		</Fragment>
	);
}

export default SOSFab;
